import $ from 'jquery';

$(function () {
  var addressData = $('.address-data-list');
  if (addressData.length) {
    $.each(addressData, function (_i, val) {
      var dataElement = $(val);
      var templateIdentifier = dataElement.data('template');
      var addressIdentifier = dataElement.data('address');
      if (templateIdentifier == null || !templateIdentifier.length) {
        return false;
      }
      var templateElement = $('body').find(templateIdentifier);
      if (!templateElement.length) {
        return false;
      }
      var template = Handlebars.compile(templateElement.html());
      var dataList = dataElement.find('.items');
      var elements = dataList.children('.items').length;
      var idOffset = -1;
      dataElement.on('click touchend', '.delete', function () {
        $(this).parents('.item').remove();
        elements--;
        if (elements == 0) {
          dataList.toggleClass('empty', true);
        }
        return false;
      });
      dataElement.on('click touchend', '.add', function () {
        dataList.append(template({ index: idOffset--, addressId: addressIdentifier }));
        elements++;
        dataList.toggleClass('empty', false);
        return false;
      });
      return false;
    });
  }

  var geoSelect = $('.geoselect');
  if (geoSelect.length) {
    var countrySelector = $('.country_selector');
    var stateSelector = $('.state_selector');
    var locationSelector = $('.location_selector');
    var districtSelector = $('.district_selector');

    if (countrySelector.length) {
      countrySelector.on('change', function () {
        var countryId = $(this).val();
        $.get('/Admin/Geo/Service/GeoStateList/Country/' + countryId, function (data) {
          if (stateSelector.length) {
            stateSelector.empty();
            stateSelector.append('<option value="0">---</option>');
          }
          if (locationSelector.length) {
            locationSelector.empty();
            locationSelector.val('');
            locationSelector.append('<option value="0">---</option>');
          }
          if (districtSelector.length) {
            districtSelector.empty();
            districtSelector.val('');
            districtSelector.append('<option value="0">---</option>');
          }
          $.each(data, function (_i, value) {
            stateSelector.append(
              $('<option/>', {
                value: value.id,
                text: value.name,
              })
            );
          });
          //console.log(data);
        });
        return false;
      });
    }
    if (stateSelector.length) {
      stateSelector.on('change', function () {
        //if (districtSelector.length) {
        //    stateId = $(this).val();
        //    $.get("/Admin/Geo/Service/GeoDistrictList/State/" + stateId, function (data) {
        //        if (locationSelector.length) {
        //            locationSelector.empty();
        //            locationSelector.val("");
        //            locationSelector.append('<option value="0">---</option>');
        //        }
        //        if (districtSelector.length) {
        //            districtSelector.empty();
        //            districtSelector.val("");
        //            districtSelector.append('<option value="0">---</option>');
        //        }
        //        $.each(data, function (index, value) {
        //            districtSelector.append($("<option/>", {
        //                value: value.id,
        //                text: value.name
        //            }));
        //        });
        //        //console.log(data);
        //    });
        //    return false;
        //} else {
        var stateId = $(this).val();
        $.get('/Admin/Geo/Service/GeoLocationList/State/' + stateId, function (data) {
          if (locationSelector.length) {
            locationSelector.empty();
            locationSelector.val('');
            locationSelector.append('<option value="0">---</option>');
          }
          if (districtSelector.length) {
            districtSelector.empty();
            districtSelector.val('');
            districtSelector.append('<option value="0">---</option>');
          }
          $.each(data, function (_i, value) {
            locationSelector.append(
              $('<option/>', {
                value: value.id,
                text: value.name,
              })
            );
          });
          //console.log(data);
        });
        return false;
        //}
      });
    }
    if (locationSelector.length) {
      locationSelector.on('change', function () {
        var locationId = $(this).val();
        $.get('/Admin/Geo/Service/GeoDistrictList/Location/' + locationId, function (data) {
          if (districtSelector.length) {
            districtSelector.empty();
            districtSelector.val('');
            districtSelector.append('<option value="0">---</option>');
          }
          $.each(data, function (_i, value) {
            districtSelector.append(
              $('<option/>', {
                value: value.id,
                text: value.name,
              })
            );
          });
          //console.log(data);
        });
        return false;
      });
    }
  }
});
